import React from "react";
import { Search, ChevronDown, X } from "lucide-react";

export default function BeneficiosFiltrosComponents({
  searchValue,
  onSearchChange,
  statusFilter,
  onStatusChange,
  statusOptions = []
}) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      {/* Barra de búsqueda */}
      {/* <div className="relative w-full sm:w-80"> */}
      <div className="relative w-full">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          <Search className="w-5 h-5" />
        </span>
        <input
          type="text"
          placeholder="Buscar por nombre"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10 pr-3 py-2 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm w-full focus:outline-none focus:ring-2 focus:ring-blue-200"
        />

        {searchValue && (
          <button
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            onClick={() => onSearchChange("")}
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>

      {/* Selector de filtros */}
      {/* <div className="relative w-full sm:w-48">
        <select
          value={statusFilter}
          onChange={(e) => onStatusChange(e.target.value)}
          className="appearance-none w-full px-3 py-2 pr-8 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer"
        >
          {statusOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
      </div> */}
    </div>
  );
}
